import React, { FC, useMemo } from 'react'

import { useDebounce } from 'use-debounce'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { DEBOUNCE_TIMER_300 } from 'src/Constants/constants'

import { useSaveGenres } from '../../helpers/useSaveGenres'
import { AdsGenresModalHeader } from '../AdsGenresModalHeader'
import { AdsGenresSearchInput } from '../AdsGenresSearchInput'
import { AdsGenresModalButtons } from '../AdsGenresModalButtons'
import { useSelectedGenres } from '../../helpers/useSelectedGenres'
import { AdSelectedGenresList } from '../AdsGenresModalReadyToSelectLists/AdSelectedGenresList'
import { AdsGenresModalReadyToSelectLists } from '../AdsGenresModalReadyToSelectLists'

import { mergeCampaignGenres } from './helpers'

export const AdsGenresModalContent: FC = () => {
  const { setSearch } = useCustomSearchParams()

  const saveGenres = useSaveGenres()
  const { selectedGenres, onSetSelectedGenres } = useSelectedGenres()

  const data = useMemo(() => mergeCampaignGenres(), [])
  const [searchValue, setSearchValue] = React.useState('')
  const [debouncedSearchValue] = useDebounce(searchValue, DEBOUNCE_TIMER_300)

  return (
    <>
      <AdsGenresModalHeader />

      <AdsGenresSearchInput
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />

      <AdSelectedGenresList
        genres={selectedGenres}
        onClickGenre={onSetSelectedGenres}
      />

      <AdsGenresModalReadyToSelectLists
        debouncedSearchValue={debouncedSearchValue}
        selectedGenres={selectedGenres}
        data={data}
        onSetSelectedGenres={onSetSelectedGenres}
      />

      <AdsGenresModalButtons
        disabledAdd={selectedGenres.length === 0}
        onClickAddGenres={() => saveGenres(selectedGenres)}
        onClickGoBack={() => setSearch({ modal: null })}
      />
    </>
  )
}
